"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requirePlan = exports.isAvailable = exports.PlanAvailability = exports.UserPlanAvailabilityTable = exports.functionNames = exports.FunctionName = exports.availableBookingCount = exports.isInFreeTrial = void 0;
const FREE_USER_AVAILABLE_BOOKING_COUNT_PER_MONTH = 10;
const isInFreeTrial = (userPlan) => {
    return userPlan.freeTrialExpireAt.toDate() >= new Date();
};
exports.isInFreeTrial = isInFreeTrial;
// 残り調整できる回数
const availableBookingCount = (userPlan) => {
    if (userPlan.plan !== 'free' || (0, exports.isInFreeTrial)(userPlan)) {
        return 'unlimited';
    }
    return FREE_USER_AVAILABLE_BOOKING_COUNT_PER_MONTH - userPlan.bookingCount;
};
exports.availableBookingCount = availableBookingCount;
exports.FunctionName = {
    schedulingCountLimit: '調整できる回数/月',
    pageLimit: '発行できるページ数',
    one: '1対1調整',
    multi: '複数人調整',
    proxy: '代理調整',
    tpb: '仲介調整',
    or: 'または調整',
    emailNotification: '確定予定をメールで通知',
    onlineMeeting: 'Zoom/GoogleMeet自動発行',
    chatNotification: 'Slack/Chatwork通知',
    multiAccount: '複数アカウント連携',
    room: '会議室の予約',
    daysLaterCanBeBooked: '開始日・終了日',
    isDaysWithAllDayEventBookable: '終日予定の予約可否',
    buffer: '前後に時間を確保',
    rescheduleAndCancel: '日程変更・キャンセル',
    isUndecidedEventBookable: '未回答/未定予定がある時間帯の予約可否',
    customizeCalendarEvent: '予定名・非公開設定',
    keyword: '空き予定とみなすキーワード',
    embed: 'サイトへの埋め込み',
    byDate: '日付の指定',
    nonParticipantsNotificationEmails: '参加者以外への確定通知',
    remind: 'リマインド',
    webhook: 'Webhook',
    redirectOnConfirm: 'リダイレクト',
    customForm: '確定フォームのカスタマイズ',
    startAndEndMessage: '調整開始/完了時のメッセージ'
};
const functionNames = (keys, separator = '、') => {
    return keys
        .map((k) => exports.FunctionName[k])
        .join(separator);
};
exports.functionNames = functionNames;
exports.UserPlanAvailabilityTable = {
    schedulingCountLimit: {
        free: 10,
        pro: '無制限',
        team: '無制限'
    },
    pageLimit: {
        free: '無制限',
        pro: '無制限',
        team: '無制限'
    },
    one: {
        free: true,
        pro: true,
        team: true
    },
    multi: {
        free: false,
        pro: false,
        team: true
    },
    proxy: {
        free: false,
        pro: false,
        team: true
    },
    tpb: {
        free: false,
        pro: false,
        team: true
    },
    or: {
        free: false,
        pro: false,
        team: true
    },
    emailNotification: {
        free: true,
        pro: true,
        team: true
    },
    onlineMeeting: {
        free: true,
        pro: true,
        team: true
    },
    chatNotification: {
        free: false,
        pro: true,
        team: true
    },
    multiAccount: {
        free: false,
        pro: true,
        team: true
    },
    room: {
        free: false,
        pro: false,
        team: true
    },
    daysLaterCanBeBooked: {
        free: true,
        pro: true,
        team: true
    },
    isDaysWithAllDayEventBookable: {
        free: true,
        pro: true,
        team: true
    },
    buffer: {
        free: true,
        pro: true,
        team: true
    },
    rescheduleAndCancel: {
        free: true,
        pro: true,
        team: true
    },
    isUndecidedEventBookable: {
        free: true,
        pro: true,
        team: true
    },
    customizeCalendarEvent: {
        free: true,
        pro: true,
        team: true
    },
    keyword: {
        free: false,
        pro: true,
        team: true
    },
    embed: {
        free: false,
        pro: true,
        team: true
    },
    byDate: {
        free: false,
        pro: true,
        team: true
    },
    nonParticipantsNotificationEmails: {
        free: false,
        pro: false,
        team: true
    },
    remind: {
        free: true,
        pro: true,
        team: true
    },
    webhook: {
        free: false,
        pro: false,
        team: true
    },
    redirectOnConfirm: {
        free: false,
        pro: false,
        team: true
    },
    customForm: {
        free: false,
        pro: false,
        team: true
    },
    startAndEndMessage: {
        free: false,
        pro: true,
        team: true
    }
};
// テーブルから各Planの情報をひいたオブジェクトを作る
const buildPlanAvailability = (plan) => {
    const planKey = plan === 'freeTrial' ? 'pro' : plan;
    return Object.entries(exports.UserPlanAvailabilityTable).reduce(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (prev, [key, value]) => {
        prev[key] = value[planKey];
        return prev;
    }, {});
};
exports.PlanAvailability = {
    free: buildPlanAvailability('free'),
    pro: buildPlanAvailability('pro'),
    team: buildPlanAvailability('team'),
    freeTrial: buildPlanAvailability('freeTrial')
};
const isAvailable = (plan, key) => {
    return exports.PlanAvailability[plan][key];
};
exports.isAvailable = isAvailable;
/**
 * 機能を利用するのに必要なプランを返す
 * @param key FunctionKey
 * @return UserPlan
 */
const requirePlan = (key) => {
    // boolじゃない値が返るので、別途対応
    if (key === 'schedulingCountLimit')
        return 'pro';
    const { pro, free } = exports.UserPlanAvailabilityTable[key];
    if (free)
        return 'free';
    if (pro)
        return 'pro';
    return 'team';
};
exports.requirePlan = requirePlan;
//# sourceMappingURL=userPlanAvailability.js.map